/**
 * LOP — PDP gallery video autoplay
 * Plays a gallery video (muted, looped) whenever it's actually visible to
 * the shopper, and pauses it otherwise. Works regardless of desktop gallery
 * style (thumbnails, list, grid) since it doesn't try to track a single
 * "active" slide — each video is observed independently via
 * IntersectionObserver, which is what its container really renders.
 *
 * The mobile carousel is a special case: swiper slides move via CSS
 * transform, not display:none, so a plain viewport-rooted observer would
 * see every slide as "visible" even when scrolled off to the side. For that
 * container the observer's root is set to the swiper element itself, so
 * intersection is measured against its own clipped (overflow:hidden) box.
 */
(function () {
  var PRODUCT_SELECTOR = '[data-section-type="product"]';
  var VISIBILITY_THRESHOLD = 0.6;

  function tryPlay(video) {
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* silent: rejected before ready — a later intersection change will retry */
      });
    }
  }

  function tryPause(video) {
    if (!video.paused) video.pause();
  }

  function observerRootFor(video) {
    var carousel = video.closest('.product__media-container.carousel.swiper');
    return carousel || null; // null = viewport
  }

  var observedVideos = new WeakSet();
  var observersByRoot = new Map(); // root element (or null) -> IntersectionObserver

  function getObserverForRoot(root) {
    var key = root || document;
    if (observersByRoot.has(key)) return observersByRoot.get(key);
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tryPlay(entry.target);
          } else {
            tryPause(entry.target);
          }
        });
      },
      { root: root, threshold: VISIBILITY_THRESHOLD }
    );
    observersByRoot.set(key, observer);
    return observer;
  }

  function observeVideo(video) {
    if (observedVideos.has(video)) return;
    observedVideos.add(video);
    getObserverForRoot(observerRootFor(video)).observe(video);
  }

  function scanSection(section) {
    section.querySelectorAll('.product__media-container video').forEach(observeVideo);
  }

  function initSection(section) {
    if (section.dataset.lopVideoAutoplayInit === 'true') return;
    section.dataset.lopVideoAutoplayInit = 'true';

    scanSection(section);

    var observer = new MutationObserver(function () {
      scanSection(section);
    });
    observer.observe(section, { subtree: true, childList: true });
  }

  function init() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
